import { useEffect, useState } from "react";
import EcommerceMetrics from "../../components/ecommerce/EcommerceMetrics";
import MonthlySalesChart from "../../components/ecommerce/MonthlySalesChart";
import StatisticsChart from "../../components/ecommerce/StatisticsChart";
import MonthlyTarget from "../../components/ecommerce/MonthlyTarget";
import RecentOrders from "../../components/ecommerce/RecentOrders";
import DemographicCard from "../../components/ecommerce/DemographicCard";
import PageMeta from "../../components/common/PageMeta";
import UserService from "../../services/user.service";
import DeckService from "../../services/decks.service";
import AnalysisChart from "@/components/ecommerce/AnalysisChart";

export default function Ecommerce() {
  const [dataUser, setDataUsers] = useState<any>({
    count: 0,
    previousMonthCount: "",
    isIncrease: false,
  });
  const [dataDeck, setDataDecks] = useState<any>({
    count: 0,
    previousMonthCount: "",
    isIncrease: false,
  });

  const fetchUsers = async () => {
    try {
      const response = await UserService.userStatistics();
      setDataUsers({
        count: response.data.count,
        percentageChange: response.data.percentageChange,
        isIncrease: response.data.isIncrease,
      });
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };

  const fetchDecks = async () => {
    try {
      const response = await DeckService.deckStatistics();
      console.log("response", response);

      setDataDecks({
        count: response.data.count,
        percentageChange: response.data.percentageChange,
        isIncrease: response.data.isIncrease,
      });
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchUsers();
      fetchDecks();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, []);

  return (
    <>
      <PageMeta
        title="VIYUME - VIYUME Dashboard"
        description=""
      />
      <div className="grid grid-cols-12 gap-4 md:gap-6">
        <div className="col-span-12 xl:col-span-12">
          <EcommerceMetrics dataUser={dataUser} dataDeck={dataDeck} />

          {/* <MonthlySalesChart /> */}
        </div>

        <div className="col-span-12 xl:col-span-12">
          {/* <MonthlyTarget /> */}
          <AnalysisChart />

        </div>

        <div className="col-span-12 xl:col-span-12">
          {/* <StatisticsChart /> */}
        </div>

        <div className="col-span-12 xl:col-span-12">
          {/* <DemographicCard /> */}
        </div>

        <div className="col-span-12 xl:col-span-12">
          {/* <RecentOrders /> */}
        </div>
      </div>
    </>
  );
}
